const CTASection = () => {
  return (
    <section className="relative py-32 lg:py-40 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/74de394e56f30081dd70a352bd036493.jpg"
          alt="おかやま整形外科の明るく清潔な待合室"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#007bbb]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8 tracking-wide">
          お気軽にご相談ください
        </h2>
        <p className="text-lg md:text-xl text-white/95 mb-4 leading-relaxed max-w-2xl mx-auto">
          初診の方もお気軽にお問い合わせください
        </p>
        <p className="text-lg md:text-xl text-white/95 mb-12 leading-relaxed max-w-2xl mx-auto">
          専門スタッフが丁寧に対応いたします
        </p>
        <a
          href="tel:086-012-3456"
          className="inline-flex items-center bg-gray-900 text-white px-10 py-4 rounded-full font-semibold hover:bg-gray-800 transition-all hover:scale-105 whitespace-nowrap"
        >
          <span className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center mr-4">
            <i className="ri-phone-line text-xl"></i>
          </span>
          今すぐ電話する
          <i className="ri-arrow-right-up-line ml-3 text-xl"></i>
        </a>
      </div>
    </section>
  );
};

export default CTASection;
